import { useEffect } from "react";
import "./TermsPrivacy.css";

export default function TermsPrivacy({ open, onAccept, onClose }) {

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="terms-overlay" onClick={onClose}>
      <div
        className="terms-sheet"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sheet-handle" />

        <section className="terms">
          <h2 className="text-center">ข้อกำหนดและเงื่อนไขการเข้าร่วมกิจกรรม “บิลรู้ใจคุณ”</h2>

          <p className="terms-sub">
          </p>

          <div className="terms-list">
            <div>
              1.ผู้ร่วมกิจกรรมต้องเป็นสมาชิกบิ๊กพอยต์ก่อนเริ่มเล่นเกม และเล่นกิจกรรมผ่านช่องทาง Line Big C TH เท่านั้น
            </div>
            <div>
              2.ระยะร่วมกิจกรรมเริ่ม 16 - 28 ก.พ. 69 หรือ จนกว่าจำนวนสิทธิ์เต็ม
            </div>
            <div>
              3.กติกาการรับของรางวัล
              <ul className="pl-2">
                <li>
                  3.1 หัวหน้าแก๊งกดแชร์กิจกรรม
                  <ul className="pl-2">
                    <li>
                      - กรณีรวมครบ 4 คน หัวหน้าแก๊ง รับคูปองแทนเงินสด 100 บาท (เมื่อซื้อสินค้า 101 บาทขึ้นไป/ใบเสร็จ)
                    </li>
                    <li>
                      - กรณีรวมไม่ครบ 4 คน หัวหน้าแก๊ง รับคูปองส่วนลด 20 บาท (เมื่อซื้อสินค้า 399 บาทขึ้นไป/ใบเสร็จ)
                    </li>
                  </ul>
                </li>

                <li>
                  3.2 เพื่อนร่วมแก๊ง ต้องเป็นสมาชิกบิ๊กพอยต์ที่สมัครสมาชิกใหม่ เท่านั้น (ทุกกรณี) รับคูปองส่วนลดคนละ 20 บาท(เมื่อซื้อสินค้า 399 บาทขึ้นไป/ใบเสร็จ)
                </li>
              </ul>
            </div>
            <div>
              4.รวมเพื่อนให้ครบ 4 คน (หัวหน้า 1 + เพื่อน 3) ภายในระยะเวลากิจกรรม (วันนี้ - 28 ก.พ. 69)
            </div>
            <div>
              5.รับคูปองทันที เมื่อภาระกิจสำเร็จหรือสิ้นสุดกิจกรรม และ ใช้คูปองได้ตั้งแต่ 16 ก.พ. - 7 มี.ค. 69 เท่านั้น
            </div>
            <div>
              6.คูปองใช้เป็นส่วนลดที่บิ๊กซี บิ๊กซีมาร์เก็ต บิ๊กซีฟู้ดเพลส และมินิบิ๊กซี (ยกเว้นบิ๊กซีออนไลน์ และ Call Chat Shop)
            </div>
            <div>
              7.จำกัดสิทธิ์การเล่นเกม 1 LINE ID / 1 สมาชิกบิ๊กพอยต์ เท่านั้น
            </div>
            <div>
              8.คูปองจากกิจกรรมนี้ไม่สามารถแลกเปลี่ยนหรือทอนเป็นเงินสด และไม่สามารถใช้ร่วมกับคูปองส่วนลดรวมถึงรายการส่งเสริมการขายอื่น
            </div>
            <div>
              9.บริษัทฯ ขอสงวนสิทธิในการเปลี่ยนแปลงหรือยกเลิก เงื่อนไขหรือรายละเอียดรายการโปรโมชั่น/กิจกรรม โดยมิต้องแจ้งให้ทราบล่วงหน้า
            </div>
            <div>
              10.จำกัดจำนวนรางวัลรวม 7,000 รางวัล (คูปองมีจำนวนจำกัด หมดแล้วหมดเลย)
            </div>
            <div>
              11.รายละเอียดของรางวัล มีดังนี้
              <ul className="pl-2">
                <li>- คูปองแทนเงินสด 100 บาท (เมื่อซื้อสินค้า 101 บาทขึ้นไป/ใบเสร็จ) จำนวน 1,000 รางวัล</li>
                <li>- คูปองส่วนลด 20 บาท (เมื่อซื้อสินค้า 399 บาทขึ้นไป/ใบเสร็จ) จำนวน 6,000 รางวัล</li>
              </ul>
            </div>
            <div>
              12.สอบถามรายละเอียดเพิ่มเติมที่ Call Center  1756
            </div>
          </div>

          <button
            className="terms-cta"
            type="button"
            onClick={onAccept}
          >
            ยอมรับและดำเนินการต่อ
          </button>
        </section>
      </div>
    </div>
  );
}
